module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/arrow/arrow-3-75.b2cf64c2.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/arrow/arrow-3-75.png
// module id = 2558
// module chunks = 11